
























import { computed, defineComponent, toRefs } from '@vue/composition-api'
import { faUser } from '@fortawesome/free-regular-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
library.add(faUser)

import timecodeFilter from '../../filters/duration.filter'
import colorScheme from '../../colorScheme'

export default defineComponent({
  name: 'KaiSpeaker',
  filters: { timecodeFilter },
  props: {
    color: {
      type: String,
      required: true,
      default: 'blue'
    },
    selected: {
      type: Boolean,
      required: true
    },
    name: {
      type: String,
      required: true,
      default: ''
    },
    timecode: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const { name, selected, color } = toRefs(props)
    // const empty = computed(() => !name.value)
    const untaggedSpeaker = computed(() =>
      name.value.toLocaleLowerCase().includes('unknown')
    )

    const style = computed(() => [
      { 'border-blue-default': selected.value },
      !untaggedSpeaker.value
        ? [colorScheme[color.value].dark, colorScheme[color.value].darkBorder]
        : 'bg-blue-light border-blue-light'
    ])

    return {
      // empty,
      style,
      untaggedSpeaker,
      userIcon: faUser
    }
  }
})
